import Heading from '@/ui/members/components/Heading';

export const Footer = () => {
  return (
    <footer className="w-full" style={{ backgroundColor: '#0e2432' }}>
      {/* Top Section - Logo and Tagline */}
      <div className="flex flex-row items-center justify-center border-b dark:border-gray-700 light:border-gray-700 py-8 px-[10%]">
        <img
          src="/images/members/header-logo.svg"
          alt="Affect Logo"
          className="h-8 md:h-12 w-auto flex-shrink-0 mr-[10%] border-r pr-[10%] dark:border-gray-700 light:border-gray-700"
        />
        <Heading value={2} className="text-xs md:text-xl leading-tight md:leading-normal">
          The Future of Mental Health and Addiction Care Is Here
        </Heading>
      </div>

      {/* Bottom Section */}
      <div className="flex flex-col items-center gap-6 px-[10%] py-10 md:flex-row md:justify-between">
        <p className="text-gray-400 text-xs leading-relaxed max-w-lg text-center md:text-left">
          Affect Therapeutics, Inc., a Delaware corporation, Affect Provider Group, P.S.C., a
          Kentucky professional services corporation, and AT Provider Group of California, P.C., a
          professional corporation, are collectively referred to as Affect.
        </p>

        <div className="flex flex-col gap-2 text-xs text-center md:text-right">
          <p>&copy; {new Date().getFullYear()} Affect Therapeutics, Inc. All rights reserved.</p>
          <div className="flex flex-wrap gap-6 justify-center md:justify-end">
            <a href="#" className="hover:text-gray-300 transition-colors whitespace-nowrap">
              Terms and Conditions
            </a>
            <a href="#" className="hover:text-gray-300 transition-colors whitespace-nowrap">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gray-300 transition-colors whitespace-nowrap">
              Data Handling
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
